import {
    LOAD_FEATURED_CATALOGS_FAIL,
    LOAD_FEATURED_CATALOGS_REQUEST,
    LOAD_FEATURED_CATALOGS_SUCCESS,
} from './actions/featuredCatalogs';
import api from '@/redux/api/featuredCatalogs';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    featuredCatalogs: [],
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_FEATURED_CATALOGS_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        case LOAD_FEATURED_CATALOGS_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case LOAD_FEATURED_CATALOGS_SUCCESS:
            return {
                ...state,
                error: false,
                errorMessage: '',
                featuredCatalogs: [...action.payload],
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.featuredCatalogs;

export const getFeaturedCatalogs = createSelector(stateSelector, (state) => state.featuredCatalogs);

/* ACTION CREATORS */
export const fetchFeaturedCatalogs = () => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_FEATURED_CATALOGS_REQUEST,
        });
        const response = await api.fetchFeaturedCatalogs({ authToken, deployment });
        return dispatch({
            meta: {
                actionTime: Date.now(),
            },
            payload: response.data,
            type: LOAD_FEATURED_CATALOGS_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_FEATURED_CATALOGS_FAIL,
        });
    }
};
